import { render, staticRenderFns } from "./confirmResult.vue?vue&type=template&id=2049c711"
import script from "./confirmResult.vue?vue&type=script&lang=js"
export * from "./confirmResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports